import type { DroneMaintenanceAdjustType, DroneMaintenancePartId } from '@src/features/fleet/redux/types';

export type Motor = 'motor';
export type Propeller = 'propeller';
export type RuntimeItemType = Motor | Propeller;

export interface RuntimeItem {
  partId: DroneMaintenancePartId;
  name: string;
  currentHours: number;
  limitHours: number;
  hoursLabel: string;
  progressValue: number;
  type: RuntimeItemType;
}

export type AdjustType = 'runtime' | 'serviceLimit';

export const ADJUST_TYPE_TO_API: Record<AdjustType, DroneMaintenanceAdjustType> = {
  runtime: 'RUNTIME',
  serviceLimit: 'LIMIT',
};

export interface AdjustPopupProps {
  type: AdjustType;
  initialValue: number;
  open: boolean;
  onClose: () => void;
  onSave: (value: number) => void;
}

export interface RuntimeItemRowProps extends RuntimeItem {
  onAdjustOptionClick?: (optionId: AdjustType, item: RuntimeItem) => void;
  onReplaceClick?: (item: RuntimeItem) => void;
}

export interface RuntimeSectionProps {
  title: string;
  items: RuntimeItem[];
  isLoading?: boolean;
  onAdjustOptionClick?: (optionId: AdjustType, item: RuntimeItem) => void;
  onReplaceClick?: (item: RuntimeItem) => void;
}
